<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="services.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
      height="calc(100vh - 350px)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="service"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :service="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="services.per_page"
        layout="total, prev, pager, next"
        :total="services.total"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      services() {
        return this.$store.getters['service/services'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['service/tableConfig']));
      },
      loading() {
        return this.$store.getters['service/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('service/setCurrentPage', val);
        this.$store.dispatch('service/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('service/setSorting', { prop, order });
        this.$store.dispatch('service/fetchAll');
      },
    },
    async mounted() {
      this.$store.commit('service/setCurrentPage', this.currentPage);
      this.$store.commit('service/setSorting', this.currentSort);
      await this.$store.dispatch('service/fetchAll');
    },
  };
</script>

